import { render, staticRenderFns } from "./TipoIncidenciasNom.vue?vue&type=template&id=de39aff2&scoped=true"
import script from "./TipoIncidenciasNom.vue?vue&type=script&lang=js"
export * from "./TipoIncidenciasNom.vue?vue&type=script&lang=js"
import style0 from "./TipoIncidenciasNom.vue?vue&type=style&index=0&id=de39aff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de39aff2",
  null
  
)

export default component.exports